import { configureStore } from '@reduxjs/toolkit'

import { setupMiddleware } from './middlewares'
import rootReducer from './reducers'

export const store = configureStore({
  reducer: rootReducer,
  middleware: setupMiddleware,
})
